import { EventEmitter, Injectable } from '@angular/core';
import { Mp3Data, RecordId, RecordUrl } from '../../types';
import { environment } from '../../../environments/environment';
import { RECORD_TOKEN_KEY } from '../../constants';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

interface UploadRecordResponse {
  id: string;
  token: string;
}

@Injectable()
export class ShareService {
  onRecordUrl: EventEmitter<RecordUrl> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
  }

  upload(mp3Data: Mp3Data): Promise<RecordUrl> {
    return this.sendResponse(mp3Data)
      .map(response => {
        const url = this.getRecordUrl(response);
        this.onRecordUrl.emit(url);
        return url;
      })
      .toPromise();
  }

  private sendResponse(mp3Data: Mp3Data): Observable<UploadRecordResponse> {
    return this.http.post(environment.apiUrl + 'records', this.createFormData(mp3Data))
      .map((response: UploadRecordResponse) => {
        localStorage.setItem(RECORD_TOKEN_KEY, response.token);
        return response;
      });
  }

  private createFormData(mp3Data: Mp3Data): FormData {
    const type = 'audio/mp3';
    const blob = new Blob(mp3Data, {type});
    const file = new File([blob], 'record.mp3', {type});
    const formData: FormData = new FormData();
    const token = localStorage.getItem(RECORD_TOKEN_KEY);

    formData.append('record', file);

    if (token) {
      formData.append('token', token);
    }

    return formData;
  }

  private getRecordUrl(response: UploadRecordResponse): RecordUrl {
    const recordId: RecordId = response.id;
    const urlBase = document.location.protocol + '//' + document.location.host + document.location.pathname;
    const urlTree = this.router.createUrlTree(['/play', recordId]);

    return urlBase + '#' + urlTree.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/services/share.service.ts